import { Injector } from "@angular/core";
import { BaseNode } from "../../BaseNode";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { ProductPreviousEvCodeEntity } from "../../../Data/MedicinalProductData/ProductPreviousEvCodeEntity";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { DevelopmentSubstanceAutoUploadEntity } from "./DevelopmentSubstanceAutoUploadEntity";
import { ApprovedSubstanceAutoUploadEntity } from "./ApprovedSubstanceAutoUploadEntity";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeProductPreviousEvCode extends BaseNode {
    useHist: boolean = false;
    cloningNode: boolean = false;
    constructor(injector: Injector, model: any, parent:any, cloningNode: boolean) {

        super(injector,
            new ProductPreviousEvCodeEntity(injector, model), 
            `${model.devevcode?model.devevcode.value:''} - ${injector.get(LookupGetService).retrieveValueFromCache('productstypes',model.type)}`);

        this.parent=parent;
        this.ioc!.get(Art57Section).generateNumColumValue(this);

        if (this.cloningNode) {
            return;
        }

        if (model.substance){
            switch (model.substance.type){
                case 1:
                    this.children?.push(new DevelopmentSubstanceAutoUploadEntity(this.ioc!, `Development - ${model.substance.ev_Code} - ${model.substance.substancename}`, this, model.substance,this.checked,true, false));
                    break;
                case 2:
                    this.children?.push(new ApprovedSubstanceAutoUploadEntity(this.ioc!, `Approved - ${model.substance.ev_Code} - ${model.substance.substancename}`, this, model.substance,this.useHist,true, false));
                    break;
            }
        }

    }

    public getListItem(): any[] {
        return [this.ioc?.get(LookupGetService).retrieveValueFromCache('productstypes',this.data.model.type),this.data.model.devevcode.value];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeProductPreviousEvCode = new TreeNodeProductPreviousEvCode(this.ioc!,this.data.model, newParent,true);      

      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)
 
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.cloningNode = false;
      return clonedNode;
    }


}